import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';

import { motorRanking, selectMotor } from './library-jis';
// import { formatDisplayValue } from '../../../lib/styles/perttierNumber';
import AlertLabel from '../../common/AlertLabel';
import { MultiErrorMessage, MultiInput, MultiOutput, MultiSelect } from '../common/MultiInput';

const DriveFormTriple = ({ drives: prevDrives, resistance, input, output }) => {
    const dispatch = useDispatch();

    const language = useSelector((state) => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;
    // const isKR = language === 'KR' ? true : false;

    const [drives, ] = useState(
        prevDrives && Array.isArray(prevDrives) && prevDrives.length === 3
            ? prevDrives
            : [
                  {
                      description: '1st Drive',
                  },
                  {
                      description: '2nd Drive',
                  },
                  {
                      description: '3rd Drive',
                  },
              ],
    );

    const { overall: overallResistance } = resistance;
    const {
        length,
        // beltWidth,
        artificialFrictionCoeff,
        beltSpeed,
        carrySpacing,
        returnSpacing,
        pipeDiameter,
        overlapAngle,
    } = input;
    const { slopeAngle, massBelt, massMaterial, massReturnIdler } = output;

    const g = 9.806;
    const FU = Number(overallResistance?.load);
    const a0 = Number(carrySpacing);
    const au = Number(returnSpacing);
    const qB = massBelt;
    const qG = massMaterial;
    const qRU = massReturnIdler;
    // const B = Number(beltWidth) / 1000; // m로 환산
    const L = Number(length);
    const delta = (slopeAngle * Math.PI) / 180; // 라디안 변환
    const f = Number(artificialFrictionCoeff);
    const D = Number(pipeDiameter) / 1000; // m로 환산
    const 𝜃 = Number(overlapAngle); // 중첩각. deg.
    const 𝜆 = 𝜃 / (360 + 𝜃); // 중첩각 비율. 무차원 수
    // props로 읽어온 변수 정리 끝.

    const [firstDrive, setFirstDrive] = useState(drives[0] || {});
    const [secondDrive, setSecondDrive] = useState(drives[1] || {});
    const [thirdDrive, setThirdDrive] = useState(drives[2] || {});

    const handleChange = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        if (category === '1st') {
            setFirstDrive((prev) => ({
                ...prev,
                [key]: value,
            }));
        } else if (category === '2nd') {
            setSecondDrive((prev) => ({
                ...prev,
                // ...prev[category],
                [key]: value,
            }));
        } else if (category === '3rd') {
            setThirdDrive((prev) => ({
                ...prev,
                // ...prev[category],
                [key]: value,
            }));
        }
    };

    const handleMotorSelection = (e) => {
        const { name, value } = e.target;
        const strArray = name.split('_');
        const category = strArray[0];
        const key = strArray[1];

        if (category === '1st') {
            const prevMotor = firstDrive.selectedMotor;
            let _selectedMotor = Number(value);
            if (value < Number(firstDrive.requiredPower)) {
                alert('모터를 다시 선택하세요');
                _selectedMotor = prevMotor;
            }
            setFirstDrive((prev) => ({
                ...prev,
                selectedMotor: _selectedMotor,
            }));
        } else if (category === '2nd') {
            const prevMotor = secondDrive.selectedMotor;
            let _selectedMotor = Number(value);
            if (value < Number(secondDrive.requiredPower)) {
                alert('모터를 다시 선택하세요');
                _selectedMotor = prevMotor;
            }
            setSecondDrive((prev) => ({
                ...prev,
                selectedMotor: _selectedMotor,
            }));
        } else if (category === '3rd') {
            const prevMotor = thirdDrive.selectedMotor;
            let _selectedMotor = Number(value);
            if (value < Number(thirdDrive.requiredPower)) {
                alert('모터를 다시 선택하세요');
                _selectedMotor = prevMotor;
            }
            setThirdDrive((prev) => ({
                ...prev,
                selectedMotor: _selectedMotor,
            }));
        }
    };

    /* 1st Drive - Actual Power 계산 */
    useEffect(() => {
        // if (!beltSpeed || !firstDrive.distribution || !FU) {
        //     return;
        // }
        const actualPowerLoad = ((Number(firstDrive.distribution) / 100) * overallResistance?.load * beltSpeed) / 1000;
        const actualPowerNoLoad =
            ((Number(firstDrive.distribution) / 100) * overallResistance?.noLoad * beltSpeed) / 1000;
        // const actualPower = Math.max(actualPowerLoad, actualPowerNoLoad);

        setFirstDrive((prev) => ({
            ...prev,
            actualPower: {
                load: Math.round(actualPowerLoad * 10) / 10,
                noLoad: Math.round(actualPowerNoLoad * 10) / 10,
            },
            // actualPower: Math.ceil(actualPower * 10) / 10,
        }));
    }, [FU, beltSpeed, firstDrive.distribution, overallResistance?.load, overallResistance?.noLoad]);

    /* 2nd Drive - Actual Power 계산 */
    useEffect(() => {
        // if (!secondDrive.distribution) {
        //     return;
        // }
        const actualPowerLoad = ((Number(secondDrive.distribution) / 100) * overallResistance?.load * beltSpeed) / 1000;
        const actualPowerNoLoad =
            ((Number(secondDrive.distribution) / 100) * overallResistance?.noLoad * beltSpeed) / 1000;
        // const actualPower = Math.max(actualPowerLoad, actualPowerNoLoad);

        setSecondDrive((prev) => ({
            ...prev,
            actualPower: {
                load: Math.round(actualPowerLoad * 10) / 10,
                noLoad: Math.round(actualPowerNoLoad * 10) / 10,
            },
            // actualPower: Math.ceil(actualPower * 10) / 10,
        }));
    }, [beltSpeed, overallResistance?.load, overallResistance?.noLoad, secondDrive.distribution]);

    /* 3rd Drive - Actual Power 계산 */
    useEffect(() => {
        // if (!thirdDrive.distribution) {
        //     return;
        // }
        const actualPowerLoad = ((Number(thirdDrive.distribution) / 100) * overallResistance?.load * beltSpeed) / 1000;
        const actualPowerNoLoad =
            ((Number(thirdDrive.distribution) / 100) * overallResistance?.noLoad * beltSpeed) / 1000;
        // const actualPower = Math.max(actualPowerLoad, actualPowerNoLoad);

        setThirdDrive((prev) => ({
            ...prev,
            actualPower: {
                load: Math.round(actualPowerLoad * 10) / 10,
                noLoad: Math.round(actualPowerNoLoad * 10) / 10,
            },
            // actualPower: Math.ceil(actualPower * 10) / 10,
        }));
    }, [beltSpeed, overallResistance?.load, overallResistance?.noLoad, thirdDrive.distribution]);

    /* 1st Drive - Required Power, Selected Motor 계산 */
    useEffect(() => {
        // if (!firstDrive.actualPower || !firstDrive.mechanicalEfficiency) {
        //     return;
        // }
        const actualPower = Math.max(firstDrive.actualPower?.load, firstDrive.actualPower?.noLoad);
        const requiredPower = actualPower / Number(firstDrive.mechanicalEfficiency);
        const selectedMotor = firstDrive.selectedMotor ?? selectMotor(requiredPower);
        const safetyMargin = selectedMotor / requiredPower;
        const isSafe = safetyMargin < 1 ? false : true;
        setFirstDrive((prev) => ({
            ...prev,
            requiredPower: Math.ceil(requiredPower * 10) / 10,
            selectedMotor,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [firstDrive.actualPower, firstDrive.mechanicalEfficiency, firstDrive.selectedMotor]);

    /* 2nd Drive - Required Power, Selected Motor 계산 */
    useEffect(() => {
        // if (!secondDrive.actualPower || !secondDrive.mechanicalEfficiency) {
        //     return;
        // }
        const actualPower = Math.max(secondDrive.actualPower?.load, secondDrive.actualPower?.noLoad);
        const requiredPower = actualPower / Number(secondDrive.mechanicalEfficiency);
        const selectedMotor = secondDrive.selectedMotor ?? selectMotor(requiredPower);
        const safetyMargin = selectedMotor / requiredPower;
        const isSafe = safetyMargin < 1 ? false : true;
        setSecondDrive((prev) => ({
            ...prev,
            requiredPower: Math.ceil(requiredPower * 10) / 10,
            selectedMotor,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [secondDrive.selectedMotor, secondDrive.actualPower, secondDrive.mechanicalEfficiency]);

    /* 3rd Drive - Required Power, Selected Motor 계산 */
    useEffect(() => {
        // if (!thirdDrive.actualPower || !thirdDrive.mechanicalEfficiency) {
        //     return;
        // }
        const actualPower = Math.max(thirdDrive.actualPower?.load, thirdDrive.actualPower?.noLoad);
        const requiredPower = actualPower / Number(thirdDrive.mechanicalEfficiency);
        const selectedMotor = thirdDrive.selectedMotor ?? selectMotor(requiredPower);
        const safetyMargin = selectedMotor / requiredPower;
        const isSafe = safetyMargin < 1 ? false : true;

        setThirdDrive((prev) => ({
            ...prev,
            requiredPower: Math.ceil(requiredPower * 10) / 10,
            selectedMotor,
            safetyMargin: Math.ceil(safetyMargin * 100) / 100,
            isSafe: !!isSafe,
        }));
    }, [thirdDrive.selectedMotor, thirdDrive.actualPower, thirdDrive.mechanicalEfficiency]);

    /* 1st Drive - Motor RPM, Rated Motor Torque 계산 */
    useEffect(() => {
        // if (!firstDrive.frequency || !firstDrive.poles || !firstDrive.selectedMotor || !firstDrive.actualPower) {
        //     return;
        // }
        const revolution = (120 * firstDrive.frequency) / firstDrive.poles;
        const ratedMotorTorque = Math.round(((974 * firstDrive.selectedMotor) / revolution) * 10) / 10;
        const actualTorqueAtMotorShaft = Math.round(((974 * firstDrive.actualPower) / revolution) * 10) / 10;

        setFirstDrive((prev) => ({
            ...prev,
            motorRPM: revolution,
            ratedMotorTorque,
            actualTorqueAtMotorShaft,
        }));
    }, [firstDrive.frequency, firstDrive.poles, firstDrive.selectedMotor, firstDrive.actualPower]);

    /* 2nd Drive - Motor RPM, Rated Motor Torque 계산 */
    useEffect(() => {
        // if (!secondDrive.frequency || !secondDrive.poles || !secondDrive.selectedMotor || !secondDrive.actualPower) {
        //     return;
        // }
        const revolution = (120 * secondDrive.frequency) / secondDrive.poles;
        const ratedMotorTorque = Math.round(((974 * secondDrive.selectedMotor) / revolution) * 10) / 10;
        const actualTorqueAtMotorShaft = Math.round(((974 * secondDrive.actualPower) / revolution) * 10) / 10;

        setSecondDrive((prev) => ({
            ...prev,
            motorRPM: revolution,
            ratedMotorTorque,
            actualTorqueAtMotorShaft,
        }));
    }, [secondDrive.frequency, secondDrive.poles, secondDrive.selectedMotor, secondDrive.actualPower]);

    /* 3rd Drive - Motor RPM, Rated Motor Torque 계산 */
    useEffect(() => {
        // if (!thirdDrive.frequency || !thirdDrive.poles || !thirdDrive.selectedMotor || !thirdDrive.actualPower) {
        //     return;
        // }
        const revolution = (120 * thirdDrive.frequency) / thirdDrive.poles;
        const ratedMotorTorque = Math.round(((974 * thirdDrive.selectedMotor) / revolution) * 10) / 10;
        const actualTorqueAtMotorShaft = Math.round(((974 * thirdDrive.actualPower) / revolution) * 10) / 10;

        setThirdDrive((prev) => ({
            ...prev,
            motorRPM: revolution,
            ratedMotorTorque,
            actualTorqueAtMotorShaft,
        }));
    }, [thirdDrive.frequency, thirdDrive.poles, thirdDrive.selectedMotor, thirdDrive.actualPower]);

    /* 1st Drive - Effective Tension 계산 */
    useEffect(() => {
        // if (!firstDrive.distribution) return;

        const effectiveTensionLoad = (Number(firstDrive.distribution) / 100) * overallResistance?.load;
        const effectiveTensionNoLoad = (Number(firstDrive.distribution) / 100) * overallResistance?.noLoad;
        // const effectiveTension = Math.max(effectiveTensionLoad, effectiveTensionNoLoad);

        setFirstDrive((prev) => ({
            ...prev,
            effectiveTension: {
                load: Math.ceil(effectiveTensionLoad),
                noLoad: Math.ceil(effectiveTensionNoLoad),
            },
            // effectiveTension: Math.ceil(effectiveTension),
        }));
    }, [firstDrive.distribution, overallResistance?.noLoad, overallResistance?.load]);

    /* 2nd Drive - Effective Tension 계산 */
    useEffect(() => {
        // if (!secondDrive.distribution) return;

        const effectiveTensionLoad = (Number(secondDrive.distribution) / 100) * overallResistance?.load;
        const effectiveTensionNoLoad = (Number(secondDrive.distribution) / 100) * overallResistance?.noLoad;
        // const effectiveTension = Math.max(effectiveTensionLoad, effectiveTensionNoLoad);

        setSecondDrive((prev) => ({
            ...prev,
            effectiveTension: {
                load: Math.ceil(effectiveTensionLoad),
                noLoad: Math.ceil(effectiveTensionNoLoad),
            },
            // effectiveTension: Math.ceil(effectiveTension),
        }));
    }, [secondDrive.distribution, overallResistance?.noLoad, overallResistance?.load]);

    /* 3rd Drive - Effective Tension 계산 */
    useEffect(() => {
        // if (!thirdDrive.distribution) return;

        const effectiveTensionLoad = (Number(thirdDrive.distribution) / 100) * overallResistance?.load;
        const effectiveTensionNoLoad = (Number(thirdDrive.distribution) / 100) * overallResistance?.noLoad;
        // const effectiveTension = Math.max(effectiveTensionLoad, effectiveTensionNoLoad);

        setThirdDrive((prev) => ({
            ...prev,
            effectiveTension: {
                load: Math.ceil(effectiveTensionLoad),
                noLoad: Math.ceil(effectiveTensionNoLoad),
            },
            // effectiveTension: Math.ceil(effectiveTension),
        }));
    }, [thirdDrive.distribution, overallResistance?.noLoad, overallResistance?.load]);

    /* 3rd Drive - Driving Factor, Slack Side Tension 계산 */
    useEffect(() => {
        // if (!thirdDrive.frictionCoeff || Number(thirdDrive.frictionCoeff) === 0 || !thirdDrive.wrapAngle) {
        //     return;
        // }
        const mu1 = Number(thirdDrive.frictionCoeff);
        const theta1 = (Number(thirdDrive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.ceil(Math.pow(Math.E, mu1 * theta1) * 100) / 100;
        const drivingFactor1 = Math.ceil((1 / (Math.pow(Math.E, mu1 * theta1) - 1)) * 1000) / 1000;
        // const drivingFactor1 = Math.ceil(1 / (Math.pow(Math.E, mu1 * theta1) - 1) * 1000) / 1000;

        const effectiveTensionLoad = Math.ceil((Number(thirdDrive.distribution) / 100) * overallResistance?.load);
        const effectiveTensionNoLoad = Math.ceil((Number(thirdDrive.distribution) / 100) * overallResistance?.noLoad);
        const requiredSlackSideTensionLoad = effectiveTensionLoad * drivingFactor1;
        const requiredSlackSideTensionNoLoad = effectiveTensionNoLoad * drivingFactor1;

        setThirdDrive((prev) => ({
            ...prev,
            emutheta,
            drivingFactor: drivingFactor1,
            // drivingFactor: Math.ceil(drivingFactor1 * 100) / 100,
            requiredSlackSideTension: {
                load: Math.ceil(requiredSlackSideTensionLoad),
                noLoad: Math.ceil(requiredSlackSideTensionNoLoad),
            },
        }));
    }, [
        overallResistance?.load,
        overallResistance?.noLoad,
        thirdDrive.distribution,
        thirdDrive.frictionCoeff,
        thirdDrive.wrapAngle,
    ]);

    /* Last(여기서는 3rd) Drive - Min., Max. Tension 계산 */ // 다른 드라이브는 계산할 필요없음
    useEffect(() => {
        // if (!thirdDrive.permissibleSagRatio || Number(thirdDrive.permissibleSagRatio) === 0) return;

        // if (!thirdDrive.distribution) return;
        // console.log('thirdDrive.distribution : ', thirdDrive.distribution);

        const mu1 = Number(thirdDrive.frictionCoeff);
        const theta1 = (Number(thirdDrive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100;
        // const drivingFactor1 = Math.ceil((1 / (Math.pow(Math.E, mu1 * theta1) - 1)) * 1000) / 1000;
        // const drivingFactor1 = 1 / (Math.pow(Math.E, mu1 * theta1) - 1);

        /* Min. Tension의 계산 */
        // 1) sag에 의한 Min. Tension
        const rate = Number(thirdDrive.permissibleSagRatio);
        // const _carrySideLoad = Math.ceil((a0 * (qB + qG) * g) / (8 * rate));
        // const _carrySideNoLoad = Math.ceil((a0 * qB * g) / (8 * rate));
        // const _returnSideLoad = Math.ceil((au * qB * g) / (8 * rate));
        // const _returnSideNoLoad = Math.ceil((au * qB * g) / (8 * rate));
        // const _minSagTensionLoad = Math.max(_carrySideLoad, _returnSideLoad);
        // const _minSagTensionNoLoad = Math.max(_carrySideNoLoad, _returnSideNoLoad);

        // In case of Pipe Conveyor
        // 1) Carry Side는 일반 컨베이어와 동일한 방식. 단 처짐 rate는 0.010
        // 2) Return Side는 두가지 방식
        //   ① 트랜지션부 처짐량 제한. 공식은 Carry Side와 동일하지만 rate는 1/60. Transition Length는 Pipe Diameter의 30배
        //   ② 판넬사이 파이프 형상 유지를 위한 최소 장력 계산.

        // 1)
        const _minTension_CSNoLoad = Math.ceil((a0 * qB * g) / (8 * rate));
        const _minTension_CSLoad = Math.ceil((a0 * (qB + qG) * g) / (8 * rate));

        const _minTension_RSNoLoad_Sag = Math.ceil((au * qB * g) / (8 * rate));
        const _minTension_RSLoad_Sag = Math.ceil((au * qB * g) / (8 * rate));

        // 2) -①
        const rateAtTransition = 0.01667; // 1/60
        const l = 30 * D; // TransitionLength. 30 times of Pipe Diameter
        const _minTension_RSNoLoad_Sag_At_Transition = Math.ceil((l * qB * g) / (8 * rateAtTransition)) || 0;
        const _minTension_RSLoad_Sag_At_Transition = Math.ceil((l * qB * g) / (8 * rateAtTransition)) || 0;

        // 2) -②
        const _minTension_RSNoLoad_PipeShape = ((16.7 * (D * 1000)) / 𝜆 + 2500 * qB) * (au ** 2 / (D * 1000)) * g || 0; // 여기서 D는 mm 단위임
        const _minTension_RSLoad_PipeShape = ((16.7 * (D * 1000)) / 𝜆 + 2500 * qB) * (au ** 2 / (D * 1000)) * g || 0; // 여기서 D는 mm 단위임

        const _minTension_RSNoLoad = Math.max(
            _minTension_RSNoLoad_Sag,
            _minTension_RSNoLoad_Sag_At_Transition,
            _minTension_RSNoLoad_PipeShape,
        );
        const _minTension_RSLoad = Math.max(
            _minTension_RSLoad_Sag,
            _minTension_RSLoad_Sag_At_Transition,
            _minTension_RSLoad_PipeShape,
        );

        // 필요 최소 텐션
        const _minSagTensionLoad = Math.max(_minTension_CSLoad, _minTension_RSLoad);
        const _minSagTensionNoLoad = Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad);

        // 2) Slope에 의한 Tension 감소
        const _slopeTensionReturnLoad = Math.ceil(L * (qB * Math.sin(delta) - f * (qRU + qB * Math.cos(delta))) * g);
        const _slopeTensionReturnNoLoad = Math.ceil(L * (qB * Math.sin(delta) - f * (qRU + qB * Math.cos(delta))) * g);

        // 3) Requied Slack Side Tension to transmit effective tension
        const effectiveTensionLoad = Math.ceil((Number(thirdDrive.distribution) / 100) * overallResistance?.load);
        const effectiveTensionNoLoad = Math.ceil((Number(thirdDrive.distribution) / 100) * overallResistance?.noLoad);
        // console.log('overallResistance.load : ', overallResistance.load);
        // console.log('effectiveTensionLoad : ', effectiveTensionLoad);
        // console.log('effectiveTensionNoLoad : ', effectiveTensionNoLoad);

        // const requiredSlackSideTensionLoad = Math.ceil(thirdDrive.drivingFactor * effectiveTensionLoad);
        // const requiredSlackSideTensionNoLoad = Math.ceil(thirdDrive.drivingFactor * effectiveTensionNoLoad);

        const _minTensionLoad = Math.max(
            thirdDrive.requiredSlackSideTension?.load,
            Math.max(_minTension_CSLoad, _minTension_RSLoad),
            Math.max(_minTension_CSLoad, _minTension_RSLoad) + _slopeTensionReturnLoad,
        );
        const _minTensionNoLoad = Math.max(
            thirdDrive.requiredSlackSideTension?.noLoad,
            Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad),
            Math.max(_minTension_CSNoLoad, _minTension_RSNoLoad) + _slopeTensionReturnNoLoad,
        );

        const T32Load = _minTensionLoad;
        const T31Load = effectiveTensionLoad + T32Load;
        const ratioLoad = Math.round((T31Load / T32Load) * 100) / 100;
        const errorMessageLoad = ratioLoad > emutheta ? 'Check!' : '';

        const T32NoLoad = _minTensionNoLoad;
        const T31NoLoad = effectiveTensionNoLoad + T32NoLoad;
        const ratioNoLoad = Math.round((T31NoLoad / T32NoLoad) * 100) / 100;
        const errorMessageNoLoad = ratioNoLoad > emutheta ? 'Check!' : '';

        /* effectiveTension Load / No Load 둘 중 큰 값으로 Max. Tension을 계산한다. */
        const effectiveTension = Math.max(effectiveTensionLoad, effectiveTensionNoLoad);
        // const minTension = Math.max(_minTensionLoad, _minTensionNoLoad);

        // Max. Tension 계산
        const _max1 =
            effectiveTension +
            Math.max(thirdDrive.requiredSlackSideTension?.load, thirdDrive.requiredSlackSideTension?.noLoad);
        const _max2 = effectiveTension + _minSagTensionLoad;
        const _max3 = effectiveTension + _minSagTensionNoLoad + _slopeTensionReturnLoad;
        const _maxTension = Math.max(_max1, _max2, _max3);

        // console.log('max : ', _max1, _max2, _max3, _maxTension);

        setThirdDrive((prev) => ({
            ...prev,
            // emutheta,
            // drivingFactor: drivingFactor1,
            // requiredSlackSideTension: {
            //     load: Math.ceil(requiredSlackSideTensionLoad),
            //     noLoad: Math.ceil(requiredSlackSideTensionNoLoad),
            // },
            minCarry: {
                // load: Math.ceil(_carrySideLoad),
                load: _minTension_CSLoad,
                // noLoad: Math.ceil(_carrySideNoLoad),
                noLoad: _minTension_CSNoLoad,
            },
            minReturn: {
                // load: Math.ceil(_returnSideLoad),
                load: _minTension_RSLoad,
                // noLoad: Math.ceil(_returnSideNoLoad),
                noLoad: _minTension_RSNoLoad,
            },
            minSagTension: {
                load: Math.ceil(_minSagTensionLoad),
                noLoad: Math.ceil(_minSagTensionNoLoad),
            },
            slopeTensionReturn: {
                load: Math.ceil(_slopeTensionReturnLoad),
                noLoad: Math.ceil(_slopeTensionReturnNoLoad),
            },
            maxTension1: Math.ceil(_max1),
            maxTension2: Math.ceil(_max2),
            maxTension3: Math.ceil(_max3),
            maxTension: Math.ceil(_maxTension),
            tightSideTension: {
                load: T31Load,
                noLoad: T31NoLoad,
            },
            slackSideTension: {
                load: T32Load,
                noLoad: T32NoLoad,
            },
            ratio: {
                load: ratioLoad,
                noLoad: ratioNoLoad,
            },
            errorMessage: {
                load: errorMessageLoad,
                noLoad: errorMessageNoLoad,
            },
        }));
    }, [
        D,
        L,
        a0,
        au,
        delta,
        f,
        overallResistance?.load,
        overallResistance?.noLoad,
        qB,
        qG,
        qRU,
        thirdDrive.distribution,
        thirdDrive.frictionCoeff,
        thirdDrive.permissibleSagRatio,
        thirdDrive.requiredSlackSideTension?.load,
        thirdDrive.requiredSlackSideTension?.noLoad,
        thirdDrive.wrapAngle,
        𝜆,
    ]);

    /* 2nd Drive - Driving Factor, Slack Side Tension 계산 */
    useEffect(() => {
        // if (!secondDrive.frictionCoeff || Number(secondDrive.frictionCoeff) === 0 || !secondDrive.wrapAngle) {
        //     return;
        // }
        const mu1 = Number(secondDrive.frictionCoeff);
        const theta1 = (Number(secondDrive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100;

        const effectiveTensionLoad = Math.ceil((Number(secondDrive.distribution) / 100) * overallResistance?.load);
        const effectiveTensionNoLoad = Math.ceil((Number(secondDrive.distribution) / 100) * overallResistance?.noLoad);

        const drivingFactor1 = 1 / (Math.pow(Math.E, mu1 * theta1) - 1);

        // console.log('drivingFactor1 : ', drivingFactor1);

        const requiredSlackSideTensionLoad = effectiveTensionLoad * drivingFactor1;
        const T22Load = Number(thirdDrive.tightSideTension?.load);
        const T21Load = T22Load + effectiveTensionLoad;
        const ratioLoad = Math.round((T21Load / T22Load) * 100) / 100;
        // console.log('eumtheta : ', Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100);
        const errorMessageLoad = ratioLoad > emutheta ? 'Check!' : '';

        const requiredSlackSideTensionNoLoad = effectiveTensionNoLoad * drivingFactor1;
        const T22NoLoad = Number(thirdDrive.tightSideTension?.noLoad);
        const T21NoLoad = T22NoLoad + effectiveTensionNoLoad;
        const ratioNoLoad = Math.round((T21NoLoad / T22NoLoad) * 100) / 100;
        // console.log('eumtheta : ', Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100);
        const errorMessageNoLoad = ratioNoLoad > emutheta ? 'Check!' : '';

        setSecondDrive((prev) => ({
            ...prev,
            emutheta,
            drivingFactor: Math.round(drivingFactor1 * 100) / 100,
            requiredSlackSideTension: {
                load: Math.ceil(requiredSlackSideTensionLoad),
                noLoad: Math.ceil(requiredSlackSideTensionNoLoad),
            },
            tightSideTension: {
                load: T21Load,
                noLoad: T21NoLoad,
            },
            slackSideTension: {
                load: T22Load,
                noLoad: T22NoLoad,
            },
            ratio: {
                load: ratioLoad,
                noLoad: ratioNoLoad,
            },
            errorMessage: {
                load: errorMessageLoad,
                noLoad: errorMessageNoLoad,
            },
        }));
    }, [
        overallResistance?.load,
        overallResistance?.noLoad,
        secondDrive.distribution,
        secondDrive.frictionCoeff,
        secondDrive.wrapAngle,
        thirdDrive.tightSideTension,
    ]);

    /* 1st Drive - Driving Factor, Slack Side Tension 계산 */
    useEffect(() => {
        // if (!firstDrive.frictionCoeff || Number(firstDrive.frictionCoeff) === 0 || !firstDrive.wrapAngle) {
        //     return;
        // }
        const mu1 = Number(firstDrive.frictionCoeff);
        const theta1 = (Number(firstDrive.wrapAngle) * Math.PI) / 180; // 라디안 변경
        const emutheta = Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100;

        const effectiveTensionLoad = Math.ceil((Number(firstDrive.distribution) / 100) * overallResistance?.load);
        const effectiveTensionNoLoad = Math.ceil((Number(firstDrive.distribution) / 100) * overallResistance?.noLoad);

        const drivingFactor1 = 1 / (Math.pow(Math.E, mu1 * theta1) - 1);

        // console.log('drivingFactor1 : ', drivingFactor1);

        const requiredSlackSideTensionLoad = effectiveTensionLoad * drivingFactor1;
        const T12Load = Number(secondDrive.tightSideTension?.load);
        const T11Load = T12Load + effectiveTensionLoad;
        const ratioLoad = Math.round((T11Load / T12Load) * 100) / 100;
        // console.log('eumtheta : ', Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100);
        const errorMessageLoad = ratioLoad > emutheta ? 'Check!' : '';

        const requiredSlackSideTensionNoLoad = effectiveTensionNoLoad * drivingFactor1;
        const T12NoLoad = Number(secondDrive.tightSideTension?.noLoad);
        const T11NoLoad = T12NoLoad + effectiveTensionNoLoad;
        const ratioNoLoad = Math.round((T11NoLoad / T12NoLoad) * 100) / 100;
        // console.log('eumtheta : ', Math.round(Math.pow(Math.E, mu1 * theta1) * 100) / 100);
        const errorMessageNoLoad = ratioNoLoad > emutheta ? 'Check!' : '';

        setFirstDrive((prev) => ({
            ...prev,
            emutheta,
            drivingFactor: Math.round(drivingFactor1 * 100) / 100,
            requiredSlackSideTension: {
                load: Math.ceil(requiredSlackSideTensionLoad),
                noLoad: Math.ceil(requiredSlackSideTensionNoLoad),
            },
            tightSideTension: {
                load: T11Load,
                noLoad: T11NoLoad,
            },
            slackSideTension: {
                load: T12Load,
                noLoad: T12NoLoad,
            },
            ratio: {
                load: ratioLoad,
                noLoad: ratioNoLoad,
            },
            errorMessage: {
                load: errorMessageLoad,
                noLoad: errorMessageNoLoad,
            },
        }));
    }, [
        firstDrive.distribution,
        firstDrive.frictionCoeff,
        firstDrive.wrapAngle,
        overallResistance?.load,
        overallResistance?.noLoad,
        secondDrive.tightSideTension?.load,
        secondDrive.tightSideTension?.noLoad,
    ]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'drives',
                value: [firstDrive, secondDrive, thirdDrive],
            }),
        );
    }, [dispatch, firstDrive, secondDrive, thirdDrive]);

    return (
        <>
            <MultiOutput
                label="Drive Description"
                variable="-"
                unit="-"
                variableName="description"
                values={[firstDrive.description, secondDrive.description, thirdDrive.description]}
                // referenceValues={["1st Drive", "2nd Drive"]}
                // onChange={handleChange}
            />
            <MultiInput
                label="Power(Tension) Distribution (Sum 100%)"
                variable="-"
                unit="%"
                variableName="distribution"
                values={[firstDrive.distribution, secondDrive.distribution, thirdDrive.distribution]}
                referenceValues={[33.3, 33.3, 33.3]}
                onChange={handleChange}
            />
            <MultiOutput
                label="Effective Tension"
                variable="Te"
                unit="N"
                variableName="effectiveTension"
                values={[
                    Math.max(firstDrive.effectiveTension?.load, firstDrive.effectiveTension?.noLoad),
                    Math.max(secondDrive.effectiveTension?.load, secondDrive.effectiveTension?.noLoad),
                    Math.max(thirdDrive.effectiveTension?.load, thirdDrive.effectiveTension?.noLoad),
                ]}
            />
            <MultiOutput
                label="Actual Power"
                variable="Pa"
                variableName="actualPower"
                unit="kW"
                values={[
                    Math.max(firstDrive.actualPower?.load, firstDrive.actualPower?.noLoad),
                    Math.max(secondDrive.actualPower?.load, secondDrive.actualPower?.noLoad),
                    Math.max(thirdDrive.actualPower?.load, thirdDrive.actualPower?.noLoad),
                ]}
            />
            <MultiInput
                label="Mechanical Efficiency"
                variable="etha"
                unit="-"
                variableName="mechanicalEfficiency"
                values={[
                    firstDrive.mechanicalEfficiency,
                    secondDrive.mechanicalEfficiency,
                    thirdDrive.mechanicalEfficiency,
                ]}
                referenceValues={[0.9, 0.9, 0.9]}
                onChange={handleChange}
            />
            <MultiOutput
                label="Motor Power Required"
                variable="PM"
                variableName="requiredPower"
                unit="kW"
                values={[firstDrive.requiredPower, secondDrive.requiredPower, thirdDrive.requiredPower]}
            />
            <MultiSelect
                label="Motor Selected"
                variable="-"
                variableName="selectedMotor"
                unit="kW"
                values={[firstDrive.selectedMotor, secondDrive.selectedMotor, thirdDrive.selectedMotor]}
                options={motorRanking}
                onChange={handleMotorSelection}
                isRequired
            />
            <MultiOutput
                label="Safety Margin(裕度)"
                variable="-"
                variableName="safetyMargin"
                unit="-"
                values={[firstDrive.safetyMargin, secondDrive.safetyMargin, thirdDrive.safetyMargin]}
                isSafeArray={[firstDrive.isSafe, secondDrive.isSafe, thirdDrive.isSafe]}
                // isSafe={[false, false,false]}
            />
            <MultiInput
                label="Slip Ratio"
                variable="-"
                unit="%"
                variableName="slipRatio"
                values={[firstDrive.slipRatio, secondDrive.slipRatio, thirdDrive.slipRatio]}
                referenceValues={[3.0, 3.0, 3.0]}
                onChange={handleChange}
            />
            <MultiSelect
                label="Frequency"
                variable="-"
                variableName="frequency"
                unit="Hz"
                values={[firstDrive.frequency, secondDrive.frequency, thirdDrive.frequency]}
                options={[
                    { text: '50Hz', value: 50 },
                    { text: '60Hz', value: 60 },
                ]}
                onChange={handleChange}
                isRequired
            />
            <MultiSelect
                label="Number of Poles"
                variable="-"
                variableName="poles"
                unit="-"
                values={[firstDrive.poles, secondDrive.poles, thirdDrive.poles]}
                options={[
                    { text: '4P', value: 4 },
                    { text: '6P', value: 6 },
                    { text: '8P', value: 8 },
                ]}
                onChange={handleChange}
                isRequired
            />
            <MultiOutput
                label="Motor RPM"
                variable="N"
                unit="1/min"
                variableName="motorRPM"
                values={[firstDrive.motorRPM, secondDrive.motorRPM, thirdDrive.motorRPM]}
            />
            <MultiOutput
                label="Rated Motor Torque"
                variable="Tm"
                unit="Nm"
                variableName="ratedMotorTorque"
                values={[firstDrive.ratedMotorTorque, secondDrive.ratedMotorTorque, thirdDrive.ratedMotorTorque]}
                referenceValues={[200, 200]}
                onChange={handleChange}
            />
            <MultiInput
                label="Wrap Angle"
                variable="theta"
                unit="deg"
                variableName="wrapAngle"
                values={[firstDrive.wrapAngle, secondDrive.wrapAngle, thirdDrive.wrapAngle]}
                referenceValues={[200, 200, 200]}
                onChange={handleChange}
            />
            <MultiInput
                label="Friction Coefficient between Pulley Lagging and Belt"
                variable="mu"
                unit="-"
                variableName="frictionCoeff"
                values={[firstDrive.frictionCoeff, secondDrive.frictionCoeff, thirdDrive.frictionCoeff]}
                referenceValues={[0.3, 0.3, 0.3]}
                onChange={handleChange}
            />
            <MultiOutput
                label="Max. Transmission Ratio" // 주어진 WrapAngle과 Friction Factor에 따른 본 풀리에서 전달할 수 있는 최대 T1/T2 비율.
                variable="-"
                unit="-"
                variableName="-"
                values={[firstDrive.emutheta, secondDrive.emutheta, thirdDrive.emutheta]}
            />
            <MultiOutput
                label="Driving Factor"
                variable="-"
                unit="-"
                variableName="drivingFactor"
                values={[firstDrive.drivingFactor, secondDrive.drivingFactor, thirdDrive.drivingFactor]}
            />
            <MultiOutput
                label="Minimum Slackside Tension to Transmit Effective Tension"
                variable="F2"
                unit="N"
                variableName="requiredSlackSideTension"
                values={[
                    firstDrive.requiredSlackSideTension?.load,
                    secondDrive.requiredSlackSideTension?.load,
                    thirdDrive.requiredSlackSideTension?.load,
                ]}
            />
            <MultiInput
                isSub
                label="Permissible Slack Rate between the Idlers(0.05 ~ 0.02)"
                variable="h/a"
                variableName="permissibleSagRatio"
                unit="-"
                values={[
                    firstDrive.permissibleSagRatio,
                    secondDrive.permissibleSagRatio,
                    thirdDrive.permissibleSagRatio,
                ]}
                referenceValues={[0.012, 0.012, 0.012]}
                onChange={handleChange}
            />
            <MultiOutput
                label="Minimum Belt Tension Required to limit the Sag"
                variable="Fmin"
                variableName="minSagTension"
                unit="N"
                values={[0, 0, thirdDrive.minSagTension?.load]}
            />
            <MultiOutput
                isSub
                label="Carry Side"
                variable="FminC"
                variableName="minCarry"
                unit="N"
                values={[0, 0, thirdDrive.minCarry?.load]}
            />
            <MultiOutput
                isSub
                label="Return Side"
                variable="FminR"
                variableName="minReturn"
                unit="N"
                values={[0, 0, thirdDrive.minReturn?.load]}
            />
            <MultiOutput
                label="Return-side Belt Tension (at Head due to Slope)"
                variable="F3"
                variableName="slopeTensionReturn"
                unit="N"
                values={[0, 0, thirdDrive.slopeTensionReturn?.load]}
            />
            <MultiOutput
                label="Max. Tension"
                variable="Fmax"
                variableName="maxTension"
                unit="N"
                values={[0, 0, thirdDrive.maxTension]}
            />
            <MultiOutput
                label="Fmax = FU + F2"
                variable=""
                variableName="maxTension1"
                unit="N"
                values={[0, 0, thirdDrive.maxTension1]}
                isSub
            />
            <MultiOutput
                label="Fmax = FU + Fmin"
                variable=""
                variableName="maxTension2"
                unit="N"
                values={[0, 0, thirdDrive.maxTension2]}
                isSub
            />
            <MultiOutput
                label="Fmax = FU + Fmin + F3"
                variable=""
                variableName="maxTension3"
                unit="N"
                values={[0, 0, thirdDrive.maxTension3]}
                isSub
            />
            <MultiOutput
                label={
                    <AlertLabel
                        label="T1 / T2 Ratio"
                        message={
                            isEN
                                ? "Should be lesser than 'Max. Transmission Ratio'"
                                : isJP
                                ? '最大先達比より小さいなければならない。'
                                : 'Max. Transmission Ratio보다 작아야 한다.'
                        }
                    />
                }
                variable="-"
                unit="-"
                variableName="ratio"
                values={[firstDrive.ratio?.load, secondDrive.ratio?.load, thirdDrive.ratio?.load]}
            />
            <MultiOutput
                label="Tight Side Tension"
                variable="F1"
                unit="N"
                variableName="tightSideTension"
                values={[
                    firstDrive.tightSideTension?.load,
                    secondDrive.tightSideTension?.load,
                    thirdDrive.tightSideTension?.load,
                ]}
            />
            <MultiOutput
                label="Slack Side Tension"
                variable="F2"
                unit="N"
                variableName="slackSideTension"
                values={[
                    firstDrive.slackSideTension?.load,
                    secondDrive.slackSideTension?.load,
                    thirdDrive.slackSideTension?.load,
                ]}
            />
            {(firstDrive.errorMessage?.load || secondDrive.errorMessage?.load || thirdDrive.errorMessage?.load) && (
                <MultiErrorMessage
                    label={
                        <AlertLabel
                            label="Error Message"
                            message={isEN ? '' : isJP ? '' : '벨트 감김각과 풀리 래깅의 마찰계수를 조정하세요.'}
                        />
                    }
                    variable="-"
                    unit="-"
                    variableName="errorMessage"
                    values={[
                        firstDrive.errorMessage?.load,
                        secondDrive.errorMessage?.load,
                        thirdDrive.errorMessage?.load,
                    ]}
                />
            )}
        </>
    );
};

export default DriveFormTriple;

/* =================   Styles   ================== */
export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: ${palette.cyan[0]};
    text-align: right;
    // width: 80px;
    padding: 0.25rem 0;
    padding-right: 0.5rem;
    font-size: 0.95rem;

    &::placeholder {
        color: ${palette.lime[5]};
        font-style: italic;
    }

    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

// export const MultiInput = ({
//     label,
//     variable,
//     unit,
//     variableName,
//     values,
//     min = '0',
//     referenceValues,
//     handleChange,
//     isRequired,
// }) => {
//     return (
//         <tr className="tr-hover-effect">
//             <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
//                 <span
//                     style={{
//                         display: 'block',
//                         width: '100%',
//                         textOverflow: 'ellipsis',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                     }}
//                 >
//                     {label}
//                 </span>
//             </td>
//             <td style={{ minWidth: '120px', fontSize: '0.9rem', color: `${palette.gray[6]}`, textAlign: 'right' }}>
//                 {variable}
//             </td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     textAlign: 'right',
//                     paddingRight: '0.5rem',
//                     // fontSize: isSub ? '0.85rem' : '0.95rem',
//                     // color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 <Input
//                     name={`1st_${variableName}`}
//                     value={values[0]}
//                     placeholder={referenceValues && referenceValues[0]}
//                     // onChange={handleChange}
//                     onChange={(e) => {
//                         const newValue = e.target.value;
//                         // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
//                         if (newValue === '' || Number(newValue) >= Number(min)) {
//                             handleChange(e);
//                         }
//                     }}
//                     isRequired={isRequired}
//                 />
//             </td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     textAlign: 'right',
//                     paddingRight: '0.5rem',
//                     // fontSize: isSub ? '0.85rem' : '0.95rem',
//                     // color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 <Input
//                     name={`2nd_${variableName}`}
//                     value={values[1]}
//                     placeholder={referenceValues && referenceValues[1]}
//                     // onChange={handleChange}
//                     onChange={(e) => {
//                         const newValue = e.target.value;
//                         // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
//                         if (newValue === '' || Number(newValue) >= Number(min)) {
//                             handleChange(e);
//                         }
//                     }}
//                     isRequired={isRequired}
//                 />
//             </td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     textAlign: 'right',
//                     paddingRight: '0.5rem',
//                     // fontSize: isSub ? '0.85rem' : '0.95rem',
//                     // color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 <Input
//                     name={`3rd_${variableName}`}
//                     value={values[2]}
//                     placeholder={referenceValues && referenceValues[2]}
//                     // onChange={handleChange}
//                     onChange={(e) => {
//                         const newValue = e.target.value;
//                         // 숫자가 아니거나 'min'보다 작으면 실행하지 않음
//                         if (newValue === '' || Number(newValue) >= Number(min)) {
//                             handleChange(e);
//                         }
//                     }}
//                     isRequired={isRequired}
//                 />
//             </td>
//             <td style={unitStyle}>{unit}</td>
//         </tr>
//     );
// };

// export const MultiOutput = ({ label, variable, unit, values, isSub }) => {
//     return (
//         <tr className="tr-hover-effect">
//             <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
//                 <span
//                     style={{
//                         display: 'block',
//                         width: '100%',
//                         paddingLeft: isSub ? '1rem' : 0,
//                         color: isSub ? `${palette.gray[6]}` : null,
//                         textOverflow: 'ellipsis',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                     }}
//                 >
//                     {label}
//                 </span>
//             </td>
//             <td style={variableStyle}>{variable}</td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     fontSize: isSub ? '0.85rem' : '0.95rem',
//                     textAlign: 'right',
//                     paddingRight: '1rem',
//                     color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 {formatDisplayValue(values[0])}
//             </td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     fontSize: isSub ? '0.85rem' : '0.95rem',
//                     textAlign: 'right',
//                     paddingRight: '1rem',
//                     color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 {formatDisplayValue(values[1])}
//             </td>
//             <td
//                 style={{
//                     minWidth: '120px',
//                     fontSize: isSub ? '0.85rem' : '0.95rem',
//                     textAlign: 'right',
//                     paddingRight: '1rem',
//                     color: isSub ? `${palette.gray[6]}` : null,
//                 }}
//             >
//                 {formatDisplayValue(values[2])}
//             </td>
//             <td style={unitStyle}>{unit}</td>
//         </tr>
//     );
// };

// const Select = styled.select`
//     width: 100%;
//     border: none;
//     outline: none;
//     padding: 0.25rem 0;
//     text-align: center;
//     background-color: ${palette.cyan[0]};
//     ${(props) =>
//         props.isRequired &&
//         css`
//             background-color: ${palette.yachtBlue};
//             color: white;
//         `}
// `;

// export const MultiSelect = ({ label, variable, unit, variableName, values, options, handleChange, isRequired }) => {
//     return (
//         <tr className="tr-hover-effect">
//             <td style={{ width: '100%', minWidth: '500px', padding: '0.5rem 1rem' }}>
//                 <span
//                     style={{
//                         display: 'block',
//                         width: '100%',
//                         textOverflow: 'ellipsis',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                     }}
//                 >
//                     {label}
//                 </span>
//             </td>
//             <td style={{ textAlign: 'right' }}>-</td>
//             <td style={{ width: '100px' }}>
//                 <Select name={`1st_${variableName}`} value={values[0]} onChange={handleChange} isRequired={isRequired}>
//                     <option value="" selected disabled hidden>
//                         Select...
//                     </option>
//                     {options.map((item) => (
//                         <option value={item.value}>{item.text}</option>
//                     ))}
//                 </Select>
//             </td>
//             <td style={{ width: '100px' }}>
//                 <Select name={`2nd_${variableName}`} value={values[1]} onChange={handleChange} isRequired={isRequired}>
//                     <option value="" selected disabled hidden>
//                         Select...
//                     </option>
//                     {options.map((item) => (
//                         <option value={item.value}>{item.text}</option>
//                     ))}
//                 </Select>
//             </td>
//             <td style={{ width: '100px' }}>
//                 <Select name={`3rd_${variableName}`} value={values[2]} onChange={handleChange} isRequired={isRequired}>
//                     <option value="" selected disabled hidden>
//                         Select...
//                     </option>
//                     {options.map((item) => (
//                         <option value={item.value}>{item.text}</option>
//                     ))}
//                 </Select>
//             </td>
//             <td>-</td>
//         </tr>
//     );
// };

const variableStyle = {
    minWidth: '100px',
    fontSize: '0.9rem',
    textAlign: 'right',
    color: `${palette.gray[6]}`,
};

const unitStyle = {
    minWidth: '60px',
    fontSize: '0.9rem',
    color: `${palette.gray[6]}`,
};

export const ErrorMessage = ({ label, variable, unit, values, isSub }) => {
    return (
        <tr>
            <td style={{ maxWidth: '1000px', minWidth: '500px', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        paddingLeft: isSub ? '1rem' : 0,
                        color: isSub ? `${palette.gray[6]}` : null,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={variableStyle}>{variable}</td>
            <td
                colSpan={2}
                style={{
                    width: '120px',
                    // textAlign: 'right',
                    paddingRight: '1.5rem',
                    color: 'red',
                }}
            >
                {(values[0] && values[0]) || (values[1] && values[1]) || (values[2] && values[2])}
            </td>

            <td style={unitStyle}>{unit}</td>
        </tr>
    );
};
